import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { useState } from 'react';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';

const NAV_LINKS = [
  { path: '/', label: 'Accueil' },
  { path: '/nos-bieres', label: 'Nos bières' },
  { path: '/professionnels', label: 'Professionnels' },
  { path: '/points-de-vente', label: 'Points de vente' },
  { path: '/location-tireuse', label: 'Location de tireuse' },
  { path: '/a-propos', label: 'À propos' },
];

const slug = (label) =>
  label.toLowerCase().replace(/ /g, '-').replace(/[àâä]/g, 'a').replace(/[èéê]/g, 'e');

export default function Header() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-white/70 border-b border-stone-200/50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3" data-testid="logo-link">
            <img
              src="https://customer-assets.emergentagent.com/job_craft-beer-shop-1/artifacts/5xgb6py8_LOGO%20SEUL.png"
              alt="Soif de Provence Logo"
              className="h-10 w-10 sm:h-12 sm:w-12 object-contain"
            />
            <span className="text-2xl sm:text-3xl font-heading text-foreground tracking-tight">Soif de Provence</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6">
            {NAV_LINKS.map(link => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-base font-medium transition-colors hover:text-primary ${
                  location.pathname === link.path ? 'text-primary' : 'text-foreground'
                }`}
                data-testid={`nav-link-${slug(link.label)}`}
              >
                {link.label}
              </Link>
            ))}
            <Link to="/contact">
              <Button className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full px-6" data-testid="nav-contact-button">
                Nous contacter
              </Button>
            </Link>
          </nav>

          {/* Mobile Navigation */}
          <div className="flex items-center lg:hidden">
            <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
              <SheetTrigger asChild>
                <button
                  className="p-2 rounded-lg hover:bg-stone-100 transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                  aria-label="Ouvrir le menu"
                  data-testid="mobile-menu-button"
                >
                  <Menu className="w-6 h-6" />
                </button>
              </SheetTrigger>
              <SheetContent side="left">
                <nav className="flex flex-col space-y-6 mt-8">
                  {NAV_LINKS.map(link => (
                    <Link
                      key={link.path}
                      to={link.path}
                      onClick={() => setMobileMenuOpen(false)}
                      className={`text-lg font-medium transition-colors ${
                        location.pathname === link.path ? 'text-primary' : 'text-foreground'
                      }`}
                      data-testid={`mobile-nav-link-${slug(link.label)}`}
                    >
                      {link.label}
                    </Link>
                  ))}
                  <Link
                    to="/contact"
                    onClick={() => setMobileMenuOpen(false)}
                    className="text-lg font-medium text-primary"
                    data-testid="mobile-nav-link-contact"
                  >
                    Nous contacter
                  </Link>
                </nav>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>
  );
}
